import { stringify } from 'qs';
import React from 'react';
import { shallowEqual } from 'react-redux';
import Config from 'config';
import { useAppSelector } from '../../../../../hooks/hooks';
import useContext from '../../../../../hooks/useContext';
import IFrameOverlay from '../../../../common/dialogs/layout/IFrameOverlay';
import { DataGridIdentifier } from './context';
import { useApiaFormContext } from '../../page/ApiaForm';

const EditionForm = () => {
  const { gridId } = useContext(DataGridIdentifier);
  const { isFormReadOnly } = useApiaFormContext();
  const { frmParent, formName, editionForm, index } = useAppSelector(
    (global) => {
      const state = global.dataGridSlice[gridId];
      return {
        frmParent: state.context.form.frmParent,
        formName: state.context.form.formData.formName,
        editionForm: state.context.grid.field.properties.gridForm,
        index: state.editionFormRow,
      };
    },
    shallowEqual,
  );
  const params = React.useMemo(
    () => ({
      frmName: editionForm,
      frmParent,
      portalFormMode: false,
      editionMode: true,
      react: true,
      index,
    }),
    [editionForm, frmParent, index],
  );
  const editionFormUrl = React.useMemo(
    () =>
      `${`${Config.APIA_ROOT_CONTEXT}/apia.execution.FormAction.run?action=editGrid${window.TAB_ID_REQUEST}`}&${stringify(
        params,
      )}&isReadonly=${String(isFormReadOnly)}`,
    [params, isFormReadOnly],
  );

  if (!editionForm) return null;

  return (
    <IFrameOverlay
      title="Edit Grid Row"
      data-grid-id={gridId}
      data-grid-form-type={frmParent}
      data-grid-form-name={formName}
      src={editionFormUrl}
    />
  );
};

export default EditionForm;
